<template>
  <Message v-if="hasState" severity="info" :closable="false" class="state-indicator mb-3">
    <div class="flex align-items-center justify-content-between">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-check-circle"></i>
        <span>
          <strong>{{ title }}</strong> {{ message }}
        </span>
      </div>
      <Button 
        v-if="showResetButton"
        label="Сбросить" 
        icon="pi pi-refresh" 
        class="p-button-sm p-button-outlined p-button-info"
        @click="$emit('reset')"
      />
    </div>
  </Message>
</template>

<script>
import Message from 'primevue/message'
import Button from 'primevue/button'

export default {
  name: 'StateIndicator',
  components: {
    Message,
    Button
  },
  props: {
    hasState: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Состояние сохранено!'
    },
    message: {
      type: String,
      default: 'Вы можете переключаться между страницами - данные не потеряются.'
    },
    showResetButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['reset']
}
</script>

<style scoped>
.state-indicator {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
